// Tiny pub/sub so a button anywhere (e.g. the header) can open the AI Assistant
// panel, which lives inside the AIAssistant component and owns its own state.
const listeners = new Set();

/** Open the AI Assistant panel from anywhere. */
export const openAI = () => { listeners.forEach(fn => { try { fn(); } catch { /* ignore */ } }); };

/** AIAssistant subscribes to this; returns an unsubscribe fn. */
export const subscribeAI = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };
